// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"107":"07d3b256","158":"6a94c2e5","308":"4a462077","351":"d62caf8e","523":"ccd068b8","618":"70de79e4","828":"93307bd7","859":"8f6843f3","989":"f655bf28"}[chunkId] + ".chunk.js";
};